export default {"src":"/_next/static/media/search.3d87b774.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};